import React from "react";
import { Box, Typography } from "@mui/material";

const PageNotFound = () => {
    const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      textAlign: "center",
      backgroundColor: "transparent",
      color: "#333",
      fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "6rem",
      margin: 0,
      color: "#ff4757", // red for error
    },
    text: {
      fontSize: "1.5rem",
      marginTop: "10px",
      color: "white"
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404</h1>
      <p style={styles.text}>Page Not Found</p>
    </div>
  );
};

export default PageNotFound;